module.exports = __webpack_public_path__ + "img/withdrawal-success.7332527c.png";